import { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import TransferenceDetailContainer from '../../components/transference-detail-container/TransferenceDetailContainer';

class TransferenceDetail extends Component {
  render() {
    return (
      <div>
        <TransferenceDetailContainer code={this.props.match.params.code} />
      </div>
    );
  }
}

TransferenceDetail.propTypes = {
  match: PropTypes.object,
};

export default withRouter(TransferenceDetail);
